<div *ngIf="!isDisplay; else showNotification"></div>
<ng-template #showNotification>
    <div class="notification-container" [ngClass]="status ? 'pivot-notification' :  'pivot-notification-err'">
        <span class="notify-content">{{notifyContent}}</span>
        <span *ngIf="typeOfNoti == type.SYNC_DATASOURCE" class="status-text">{{status ? MESSAGE_TEXT.UPDATE_SUCCESS : MESSAGE_TEXT.UPDATE_FAIL}}</span>
    </div>
</ng-template>